
function isset(object){
    return (typeof object !=='undefined');
}

function hideDiv(id) { 
	document.getElementById(id).style.display = 'none'; 
}